import { MilestoneStatus } from '@models';

const MILESTONE_VIEWER_TOOLTIP_LEGENDS = [
  {
    label: 'Upcoming',
    icon: 'arrow-right-circle',
    iconColor: '#70707A',
    description: 'Tasks scheduled for the future.',
    barIcon: 'bar-upcoming'
  },
  {
    label: 'Completed',
    icon: 'checked-circle-bold',
    iconColor: '#005DAA',
    description: 'Tasks that have been finished.',
    barIcon: 'bar-completed'
  },
  {
    label: 'In progress/On track',
    icon: 'like',
    iconColor: '#01891E',
    description: 'Work ongoing or milestone on track.',
    barIcon: 'bar-in-progress'
  },
  {
    label: 'Past due/Off track',
    icon: 'exclamation-circle-bold',
    iconColor: '#B60150',
    description: 'Work is overdue and needs attention.',
    barIcon: 'bar-off-track'
  },
  {
    label: 'At risk',
    icon: 'warning-bold',
    iconColor: '#D14700',
    description: 'Delays may impact progress.',
    barIcon: 'bar-at-risk'
  }
];

const MILESTONE_STATUS_TO_ICON: Record<MilestoneStatus, { icon: string; color: string }> = {
  'Completed | Accelerated': { icon: 'checked-circle-bold', color: '#005DAA' },
  Completed: { icon: 'checked-circle-bold', color: '#005DAA' },
  'Completed | Late': { icon: 'checked-circle-bold', color: '#005DAA' },
  'Completed | On Time': { icon: 'checked-circle-bold', color: '#005DAA' },
  'Past Due': { icon: 'exclamation-circle-bold', color: '#B60150' },
  'On Track': { icon: 'like', color: '#01891E' },
  'At Risk': { icon: 'warning-bold', color: '#D14700' },
  Upcoming: { icon: 'arrow-right-circle', color: '#70707A' }
};

export { MILESTONE_STATUS_TO_ICON, MILESTONE_VIEWER_TOOLTIP_LEGENDS };
